// 9fbef606107a605d69c0edbcd8029e5d
export const shippingEmailSignUpHeaderCANew = 'lbl_shipping_emailSignUpHeader_ca_new';
export const shippingEmailSignUpHeader = 'lbl_shipping_emailSignUpHeader';
export const shippingEmailSignUpSubHeader = 'lbl_shipping_emailSignUpSubHeader';
export const shippingEmailSignUpDisclaimer = 'lbl_shipping_emailSignUpDisclaimer';
export const shippingGymboreePlaceCheckoutTxt = 'lbl_shipping_gymboreePlaceCheckoutTxt';
export const shippingAddressEditError = 'lbl_shipping_addressEditError';
export const lblTcp = 'lbl_tcp';
export const privacyPolicy = 'lbl_smsSignup_privacyPolicy';
export const orderUpdates = 'lbl_smsSignup_orderUpdates';

export const contactFormLabelsObj = {
  checkout: {
    shipping: {
      [shippingEmailSignUpHeaderCANew]: 'Sign Up For Emails',
      [shippingEmailSignUpHeader]: 'SIGN UP FOR EMAILS*',
      [shippingEmailSignUpSubHeader]: 'Stay updated on special promos & new arrivals.',
      [shippingEmailSignUpDisclaimer]:
        '*You may withdraw your consent at any time. Contact Us: The Children’s Place and Gymboree, 500 Plaza Drive, Secaucus, NJ 07094, <a href="/" style="color:black;">www.childrensplace.com</a> and <a href="/" style="color:black;">www.gymboree.com</a>.',
      [shippingGymboreePlaceCheckoutTxt]: 'Gymboree',
      [shippingAddressEditError]: 'Please save your changes or cancel to proceed with checkout',
    },
  },
};

export const globalLabelsObj = {
  global: {
    generic: {
      [lblTcp]: "The Children's Place",
    },
  },
};

export const smsSignupLabelsObj = {
  global: {
    smsSignup: {
      [privacyPolicy]: 'Privacy Policy.',
      [orderUpdates]: 'Send me order updates via text messages',
    },
  },
};

export const saveAndContinue = 'lbl_addEditAddress_saveAndContinue';

export const addEditAddressLabelsObj = {
  global: {
    addEditAddress: {
      [saveAndContinue]: 'Save & Continue',
    },
  },
};
